<div class="agents-container">
  <!-- Filter bar -->
  <div class="filters">
    <div class="search-filter-group">
      <!-- Search Box -->
      <div
        class="search-box"
        [style.width]="!searchInput.value ? 'auto' : null"
      >
        <div class="search-field">
          <input
            type="text"
            placeholder="{{ 'agent.listing.search' | translate }}"
            [formControl]="searchInput"
            (input)="search($event)"
            [style.width]="!searchInput.value ? 'auto' : null"
            [attr.size]="
              !searchInput.value
                ? ('agent.listing.search' | translate).length
                : null
            "
          />
          <div class="search-icon">
            <img src="assets/icones/search_icon.svg" alt="" />
          </div>
        </div>
      </div>
      <!-- Assign All Toggle -->
      <div class="assign-all-container">
        <mat-slide-toggle
          [checked]="assignAll"
          [disabled]="!canSubmit"
          (change)="toggleAssignAll()"
        ></mat-slide-toggle>
        <ui-button
          *appHasPermission="submitPermission()"
          [label]="'Catalogs.new_catalog.agents.assign_all' | translate"
          type="transparent"
          (click)="toggleAssignAll()"
        ></ui-button>
        
      </div>
    </div>
  </div>

  <!-- No agents message -->
  <div class="empty-agents-message" *ngIf="filteredAgents.length === 0">
    <div class="message-content">
      <p>{{ 'agent.listing.no_data' | translate }}</p>
    </div>
  </div>
  <!-- Agents table -->
  <div class="agents-content" *ngIf="filteredAgents.length > 0">
    <table class="agents-table">
      <thead>
        <tr class="row header">
          <!-- Agent Name -->
          <th class="sortable-column">{{ 'agent.listing.fullname' | translate }}</th>
          <!-- Is Assigned -->
          <th style="width: 160px;" class="sortable-column">{{ 'Catalogs.new_catalog.agents.assigned' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport itemSize="50" class="agents-viewport">
          <ng-container *cdkVirtualFor="let agent of filteredAgents">
            <tr class="row">
              <!-- Agent name -->
              <td style="text-transform: capitalize">
                {{ getAgentFullname(agent) }}
              </td>
              <!-- Is Assigned -->
              <td style="width: 160px;">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                  <label class="switch">
                    <input type="checkbox" [checked]="agentIsChecked(agent)" [disabled]="!canSubmit" (change)="toggleAgent(agent)"/>
                    <span class="slider round"></span>
                  </label>
                  <!-- <button class="action-btn secondary-btn icon-btn" style="color: #454545" [disabled]="!agentIsChecked(agent)">
                    <span class="icon">
                      <app-svg-icon svgIcon="send-cc"></app-svg-icon>
                    </span>
                  </button> -->
                </div>
              </td>
            </tr>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
